// Function loadWoolLabMySwatchesBlock loads the WoolLabMySwatchesBlock class by dynamically importing the js on demand if needed

export function loadWoolLabMySwatchesBlock($parentEl, isList = false) {

	return import(/* webpackChunkName: "wg-fabric-swatch-favourites-block-chunk" */ '../widgets/woolLabMySwatchesBlock').then(wg => {

		const { WoolLabMySwatchesBlock } = wg;

		let $wg = $parentEl.querySelector('[data-wg="WoolLabMySwatchesBlock"]');

		if(!$wg) {
			// console.info('WoolLabMySwatchesBlock: no widget found');
			return null;
		}

		if (isList) {
			let $wgCol = $parentEl.querySelectorAll('[data-wg="WoolLabMySwatchesBlock"]');
			let instances = [];
			$wgCol.forEach(($wg, i) => {
				instances.push( new WoolLabMySwatchesBlock($wg) );
			});
			if (instances.length === $wgCol.length) return instances;

		} else {
			return new WoolLabMySwatchesBlock($wg);
		}


	}).catch(error => error+'An error occurred while loading the WoolLabMySwatchesBlock widget');

}
